import React, { useState, useEffect } from 'react';

const API_URL = 'https://skortes.com';

export default function GamifikasiCard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) { setLoading(false); return; }
    fetch(`${API_URL}/api/gamifikasi/ringkasan`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json())
      .then(d => { setData(d); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  if (loading || !data) return null;

  const { level, progresLevel, xpPerLevel, badges, dailyChallenge } = data;
  const persenLevel = Math.min(100, Math.round((progresLevel / xpPerLevel) * 100));
  const badgeTercapai = badges.filter(b => b.tercapai);

  return (
    <div className="rounded-xl overflow-hidden" style={{ border: '1px solid var(--border)' }}>
      {/* Level & XP bar */}
      <div className="px-4 py-3" style={{ backgroundColor: 'var(--bg-card2)' }}>
        <div className="flex items-center justify-between mb-1.5">
          <div className="flex items-center gap-2">
            <span className="text-lg">⭐</span>
            <p className="font-bold text-sm" style={{ color: 'var(--text-primary)', fontFamily: "'Poppins', sans-serif" }}>
              LEVEL {level}
            </p>
          </div>
          <p className="text-xs font-mono" style={{ color: 'var(--text-muted)' }}>
            {progresLevel} / {xpPerLevel} XP
          </p>
        </div>
        <div className="h-2 rounded-full overflow-hidden" style={{ backgroundColor: 'var(--bg-app)' }}>
          <div className="h-full rounded-full transition-all" style={{ width: `${persenLevel}%`, backgroundColor: 'var(--accent)' }} />
        </div>
      </div>

      {/* Daily Challenge */}
      <div className="px-4 py-3 flex items-center gap-3"
           style={{ backgroundColor: dailyChallenge.selesaiHariIni ? 'rgba(74,222,128,0.08)' : 'var(--bg-card)', borderTop: '1px solid var(--border)' }}>
        <span className="text-xl">{dailyChallenge.selesaiHariIni ? '✅' : '🎯'}</span>
        <div className="flex-1 min-w-0">
          <p className="text-xs font-semibold" style={{ color: 'var(--text-primary)' }}>
            Daily Challenge {dailyChallenge.selesaiHariIni && '— Selesai!'}
          </p>
          <p className="text-[11px]" style={{ color: 'var(--text-muted)' }}>{dailyChallenge.deskripsi}</p>
        </div>
        <span className="text-xs font-bold font-mono shrink-0" style={{ color: 'var(--accent)' }}>
          +{dailyChallenge.bonusXp} XP
        </span>
      </div>

      {/* Badge */}
      <div className="px-4 py-3" style={{ backgroundColor: 'var(--bg-card)', borderTop: '1px solid var(--border)' }}>
        <div className="flex items-center justify-between mb-2">
          <p className="text-[10px] uppercase tracking-wider" style={{ color: 'var(--text-muted)' }}>Lencana</p>
          <p className="text-[10px]" style={{ color: 'var(--accent)' }}>{badgeTercapai.length}/{badges.length} tercapai</p>
        </div>
        <div className="flex flex-wrap gap-2">
          {badges.map(b => (
            <div key={b.id} title={b.label}
                 className="flex flex-col items-center justify-center rounded-lg px-2.5 py-2 w-[68px]"
                 style={{
                   backgroundColor: b.tercapai ? 'rgba(192,160,98,0.12)' : 'var(--bg-card2)',
                   border: `1px solid ${b.tercapai ? 'var(--accent)' : 'var(--border)'}`,
                   opacity: b.tercapai ? 1 : 0.45,
                 }}>
              <span className="text-lg">{b.icon}</span>
              <span className="text-[8px] text-center leading-tight mt-1" style={{ color: b.tercapai ? 'var(--text-primary)' : 'var(--text-faint)' }}>
                {b.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
